// extracted by mini-css-extract-plugin
export default {"container":"EmailThreadAccordion_container__y6G4T","summaryContainer":"EmailThreadAccordion_summaryContainer__OcBzV"};